































































































































import _ from "lodash";
import "devextreme/dist/css/dx.light.css";

import { Component, Vue, Prop } from "vue-property-decorator";
import { Action, Getter, Mutation } from "vuex-class";
import { Maintenancejob, Property } from "@/models";
import { DxDateBox } from "devextreme-vue/date-box";
import ProgressButton from "@/components/ProgressButton.vue";

@Component({
  components: {
    DxDateBox,
    ProgressButton
  }
})
export default class MaintenancejobDetail extends Vue {
  @Prop({ default: false }) public showsidebar: boolean;

  @Getter("maintenancejobs/hasUnsavedChanges")
  public hasUnsavedChanges: boolean;
  @Getter("auth/isBaseUser") public isBaseUser: boolean;


  @Getter("maintenancejobs/current") public maintenancejob: Maintenancejob;
  @Getter("maintenancejob/list") public list: Property[];

  @Getter("maintenancejobs/list") public maintenancejoblist: Maintenancejob[];

  @Mutation("maintenancejobs/setCurrent")
  public setCurrent: (maintenancejob: Maintenancejob) => void;

  @Action("maintenancejobs/getMaintenancejob")
  public getMaintenancejob: (id: string) => Promise<Maintenancejob>;
  @Mutation("app/removeRequest")
  public removeRequest: (id: string) => void;

  @Action("maintenancejobs/setMaintenancejobDeep")
  public setMaintenancejobDeep: (payload: {
    path: string;
    data: any;
  }) => Promise<any>;

  @Action("maintenancejobs/addMaintenancejob")
  public addMaintenancejob: (maintenancejob: Maintenancejob) => Promise<any>;

  @Action("maintenancejobs/updateMaintenancejob")
  public updateMaintenancejob: (maintenancejob: Maintenancejob) => Promise<any>;
  @Action("maintenancejobs/generateMaintenancejobPdf")
  generateMaintenancejobPdf: (payload: {
    maintenancejob: Maintenancejob;
    downloadType: string;
  }) => Promise<any>;

  public async mounted() {
    if (this.isNewMaintenancejob()) {
      this.setCurrent(new Maintenancejob());
    } else {
      this.getMaintenancejob(this.$router.currentRoute.params.id);
    }
  }

  get createdate() {
    return this.maintenancejob.createdate;
  }
  set createdate(data) {
    this.setMaintenancejobDeep({ path: "createdate", data });
  }

  get targetdate() {
    return this.maintenancejob.targetdate;
  }
  set targetdate(data) {
    this.setMaintenancejobDeep({ path: "targetdate", data });
  }

  get addressLine1() {
    return this.maintenancejob.address.line1;
  }
  set addressLine1(data) {
    this.setMaintenancejobDeep({ path: "address.line1", data });
  }

  public addressPreviewLine1() {
    return `${this.addressLine1}${
      this.addressLine2 ? `, ${this.addressLine2}` : ""
    }`;
  }
  public addressPreviewLine2() {
    return `${this.addressPostcode}`;
  }

  get addressLine2() {
    return this.maintenancejob.address.line2;
  }
  set addressLine2(data) {
    this.setMaintenancejobDeep({ path: "address.line2", data });
  }
  public checkStatus(){
    return this.maintenancejob.invoice.fees.length && this.maintenancejob.invoice.fees.every(fee => fee.status === 'Completed');
  }

  get addressTown() {
    return this.maintenancejob.address.town;
  }
  set addressTown(data) {
    this.setMaintenancejobDeep({ path: "address.town", data });
  }

  get addressCounty() {
    return this.maintenancejob.address.county;
  }
  set addressCounty(data) {
    this.setMaintenancejobDeep({ path: "address.county", data });
  }

  get addressPostcode() {
    return this.maintenancejob.address.postcode;
  }
  set addressPostcode(data) {
    this.setMaintenancejobDeep({ path: "address.postcode", data });
  }

  get completiondate() {
    return this.maintenancejob.completiondate;
  }
  set completiondate(data) {
    this.setMaintenancejobDeep({ path: "completiondate", data });
  }

  public clearStatus() {
    this.setMaintenancejobDeep({ path: "status", data: "" });
  }

  public setStatus(val: string) {
    this.setMaintenancejobDeep({ path: "status", data: val });
  }

  get status() {
    return this.maintenancejob.status;
  }
  set status(data) {
    this.setMaintenancejobDeep({ path: "status", data });
  }

  public canSave() {
    let result = true;
    if (
      !this.maintenancejob.address.line1 ||
      !this.maintenancejob.address.postcode ||
      !this.maintenancejob.defectid
    )
      result = false;
    return result;
  }

  public isNewMaintenancejob() {
    return this.$router.currentRoute.params.id == "new";
  }

  public isSaving: boolean = false;
  public saveAll() {
    if (this.isNewMaintenancejob()) {
      this.isSaving = true;
      this.addMaintenancejob(this.maintenancejob).then(() => {
        this.isSaving = false;
        this.$toasted.success("Added");
        this.$router.push("/maintenancejobs");
      });
    } else {
      this.isSaving = true;
      this.updateMaintenancejob(this.maintenancejob).then(() => {
        this.isSaving = false;
        this.$toasted.success("Saved");
        this.$router.push("/maintenancejobs");
      });
    }
  }

  public cancel() {
    this.setCurrent(new Maintenancejob());
    this.$router.push("/maintenancejobs");
  }

  public statusOptions: string[] = [
    "New",
    "Unallocated",
    "Allocated",
    "In Progress",
    "On Hold",
    "Completed"
  ];
  /**
   * Download Maintenancejob/Invoice/Proforma PDF
   *
   * @param {Maintenancejob} maintenancejob
   * @param {String} downloadType
   */
  public generatePdf(
    maintenancejob: Maintenancejob,
    downloadType: string,
    requestId: string
  ): void {
    this.generateMaintenancejobPdf({ maintenancejob, downloadType })
      .then((key: string) => {
        this.$onecentral.downloadAttachment(key);
        this.$toasted.success(
          `${downloadType} for ${maintenancejob.ref} PDF downloaded`
        );
      })
      .finally(() => this.removeRequest(requestId))
      .catch((err: any) => this.$onecentral.displayError(err));
  }
}
